import styled from 'styled-components';
import { 
  FormControl, 
  Select, 
  InputLabel, 
  Button, 
  Popover 
} from '@mui/material';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';

import { theme } from '../../constants/theme';
import { Text18 } from '../../ui/Text18';

export const Wrapper = styled.div`
  color: ${theme.colors.stepActiveColor};
`;

export const AllInputsWrapper = styled.div`
  display: flex;
  margin-top: 64px;
  gap: 24px;
  @media (max-width: 1035px) {
    flex-direction: column;
  }
`;

export const AllInsurances = styled.button<{ disabled?: boolean }>`
  ${({ disabled }) =>
    disabled && 'background-color: grey; pointer-events: none; cursor: none'};
  margin-top: 40px;
`;

export const InputWrapper = styled.div`
  width: 30%;
  @media (max-width: 1035px) {
    width: 100%;
  }
  height: 100px;
`;

export const InputTitle = styled.h4`
  color: ${({ theme }) => theme.colors.blackColor};
  margin-bottom: 16px;
`;

export const FormCountry = styled(FormControl)`
  margin-top: 32px;
  height: 20px;
`;

export const PopularCountries = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 40px;
`;

export const PopularCountryText = styled(Text18)`
  color: ${({ theme }) => theme.colors.accentBlue};
  cursor: pointer;
  z-index: 1;
`;

export const SelectWrapper = styled(Select)`
  height: 56px;
`;

export const Label = styled(InputLabel)`
  background-color: white;
`;

export const TuristsSelector = styled.div<{ isActive: boolean }>`
  border: 1px solid ${({ isActive }) => (isActive ? '#455a64' : '#cfd8dc')};
  margin-top: 16px;
  height: 54px;
  border-radius: 4px;
  padding: 0 10px;
  display: flex;
  gap: 15px;
`;

export const TouristWrapper = styled.div`
  pointer-events: none;
  display: flex;
  align-items: center;
  height: 100%;
`;

export const TouristModalWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const PopoverWrapper = styled.div<{ width: number }>`
  min-height: 300px;
  width: ${({ width }) => width}px;
  display: flex;
  justify-content: center;
`;

export const TouristElement = styled.div`
  margin-bottom: 20px;
`;

export const TouristElementHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TouristOrder = styled(Text18)`
  font-weight: 700;
`;

export const DeleteButton = styled(Button)`
  width: 70px;
`;

export const DeleteText = styled(Text18)`
  font-size: 16px !important;
  text-transform: none;
`;

export const AddTourist = styled(Button)``;

export const PopoverModal = styled(Popover)``;

export const TouristsWrapper = styled.div`
  width: 100%;
  margin: 20px;
`;

export const DateInputWrapper = styled.div`
  width: 40%;
  @media (max-width: 1035px) {
    width: 100%;
  }
  height: 100px;
`;

export const DateInputTitle = styled.h4`
  color: ${({ theme }) => theme.colors.blackColor};
  margin-bottom: 16px;
`;

export const DatesInput = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  gap: 10px;
`;

export const DatePickerWrapper = styled(LocalizationProvider)`
  width: 50%;
`;

export const DatePicker = styled(DesktopDatePicker)``;

